export enum UserPresenceState {
  Available = 'User Available',
  Busy = 'User Busy',
  Holiday = 'On Holiday',
  Lunch = 'On Lunch',
  Meeting = 'In a Meeting',
  OutOfOffice = 'Out of Office',
}
